/** Fixed-timestep loop: simulation ticks at 60 Hz, rendering runs at display rate. */
export const TICK = 1 / 60;
/** Longest stretch of real time one frame may catch up on. Short, so a slow phone runs slightly slower
 * instead of running many game steps per frame and getting slower still. */
const MAX_FRAME = 0.1;

export interface LoopHandlers {
  update(dt: number): void;
  render(alpha: number): void;
}

export class Loop {
  private accumulator = 0;
  private last = 0;
  private frame = 0;
  private running = false;

  constructor(private readonly handlers: LoopHandlers) {}

  start(): void {
    if (this.running) return;
    this.running = true;
    this.last = performance.now();
    this.frame = requestAnimationFrame(this.step);
  }

  stop(): void {
    this.running = false;
    cancelAnimationFrame(this.frame);
  }

  private readonly step = (now: number): void => {
    if (!this.running) return;
    const elapsed = Math.min(MAX_FRAME, (now - this.last) / 1000);
    this.last = now;
    this.accumulator += elapsed;
    while (this.accumulator >= TICK) {
      this.handlers.update(TICK);
      this.accumulator -= TICK;
    }
    this.handlers.render(this.accumulator / TICK);
    this.frame = requestAnimationFrame(this.step);
  };
}
